const best50 = [
	{
		insttCd: "A1AABG0000",
		insttNm: "농협은행 주식회사",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAEO0000",
		insttNm: "주식회사 국민은행",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAER0000",
		insttNm: "주식회사 신한은행",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAHJ0000",
		insttNm: "주식회사 카카오뱅크",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAEM0000",
		insttNm: "(주)우리은행",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAEQ0000",
		insttNm: "중소기업은행",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAES0000",
		insttNm: "주식회사 하나은행",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAKA0000",
		insttNm: "우정사업본부",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAPF0000",
		insttNm: "토스뱅크 주식회사",
		indstCd: "bank",
	},
	{
		insttCd: "A1AAJB0000",
		insttNm: "케이뱅크은행",
		indstCd: "bank",
	}, // 10
	// {
	// 	insttCd: "A4AAAZ0000",
	// 	insttNm: "농업협동조합중앙회",
	// 	indstCd: "bank",
	// },
	// {
	// 	insttCd: "A4AAPA0000",
	// 	insttNm: "새마을금고중앙회",
	// 	indstCd: "bank",
	// },
	{
		insttCd: "D1AAAF0000",
		insttNm: "KB국민카드",
		indstCd: "card",
	},
	// {
	// 	insttCd: "D1AABJ0000",
	// 	insttNm: "하나카드 주식회사",
	// 	indstCd: "card"
	// },
	{
		insttCd: "D1AADO0000",
		insttNm: "롯데카드 주식회사",
		indstCd: "card"
	},
	{
		insttCd: "D1AAEV0000",
		insttNm: "삼성카드 주식회사",
		indstCd: "card"
	},
	{
		insttCd: "D1AAEX0000",
		insttNm: "신한카드 주식회사",
		indstCd: "card"
	},
	{
		insttCd: "D1AAFO0000",
		insttNm: "현대카드",
		indstCd: "card"
	},
	{
		insttCd: "D1AAHJ0000",
		insttNm: "주식회사 카카오뱅크",
		indstCd: "card"
	},
	// {
	// 	insttCd: "D1AABG0000",
	// 	insttNm: "농협은행 주식회사",
	// 	indstCd: "card"
	// },
	// {
	// 	insttCd: "D1AAAH0000",
	// 	insttNm: "주식회사 우리카드",
	// 	indstCd: "card"
	// }, //20
	{
		insttCd: "D1AAFQ0000",
		insttNm: "비씨카드 주식회사",
		indstCd: "card"
	},
	{
		insttCd: "D1AAPF0000",
		insttNm: "토스뱅크 주식회사",
		indstCd: "card"
	},
	// {
	// 	insttCd: "D1AAQE0000",
	// 	insttNm: "한국씨티은행",
	// 	indstCd: "card"
	// },
	{
		insttCd: "B1AAAR0000",
		insttNm: "삼성생명보험",
		indstCd: "insu"
	},
	{
		insttCd: "B2AAAL0000",
		insttNm: "현대해상화재보험",
		indstCd: "insu"
	},
	{
		insttCd: "B2AADH0000",
		insttNm: "한화손해보험",
		indstCd: "insu"
	},
	// {
	// 	insttCd: "B2AAEN0000",
	// 	insttNm: "디비손해보험 주식회사",
	// 	indstCd: "insu"
	// },
	// {
	// 	insttCd: "B2AALR0000",
	// 	insttNm: "KB손해보험",
	// 	indstCd: "insu"
	// },
	// {
	// 	insttCd: "B1AAAI0000",
	// 	insttNm: "교보생명보험(주)",
	// 	indstCd: "insu"
	// }, //30
	// {
	// 	insttCd: "B1AAQI0000",
	// 	insttNm: "한화생명보험 (주)",
	// 	indstCd: "insu"
	// },
	// {
	// 	insttCd: "B2AACR0000",
	// 	insttNm: "메리츠화재해상보험주식회사",
	// 	indstCd: "insu"
	// },
	{
		insttCd: "C1AABR0000",
		insttNm: "키움증권",
		indstCd: "invest"
	},
	{
		insttCd: "C1AACT0000",
		insttNm: "한국투자증권",
		indstCd: "invest"
	},
	// {
	// 	insttCd: "C1AACU0000",
	// 	insttNm: "미래에셋증권 주식회사",
	// 	indstCd: "invest"
	// },
	{
		insttCd: "C1AADA0000",
		insttNm: "KB증권",
		indstCd: "invest"
	},
	// {
	// 	insttCd: "C1AAEY0000",
	// 	insttNm: "삼성증권",
	// 	indstCd: "invest"
	// },
	// {
	// 	insttCd: "C1AAHW0000",
	// 	insttNm: "토스증권 주식회사",
	// 	indstCd: "invest"
	// },
	// {
	// 	insttCd: "C1AAKO0000",
	// 	insttNm: "대신증권(주)",
	// 	indstCd: "invest"
	// },
	{
		insttCd: "C1AACQ0000",
		insttNm: "NH투자증권",
		indstCd: "invest"
	}, //40
	// {
	// 	insttCd: "E1AADV0000",
	// 	insttNm: "비바리퍼블리카",
	// 	indstCd: "efin"
	// },
	{
		insttCd: "E1AAHY0000",
		insttNm: "네이버파이낸셜 주식회사",
		indstCd: "efin"
	},
	{
		insttCd: "E1AAIA0000",
		insttNm: "주식회사 카카오페이",
		indstCd: "efin"
	},
	{
		insttCd: "E1AAIE0000",
		insttNm: "엔에이치엔페이코 주식회사",
		indstCd: "efin"
	},
	// {
	// 	insttCd: "E1AAQK0000",
	// 	insttNm: "우아한형제들",
	// 	indstCd: "efin"
	// },
	// {
	// 	insttCd: "E1AAPC0000",
	// 	insttNm: "(주)카카오",
	// 	indstCd: "efin"
	// },
	{
		insttCd: "E1AAPM0000",
		insttNm: "SSG닷컴",
		indstCd: "efin"
	},
	// {
	// 	insttCd: "E1AAPN0000",
	// 	insttNm: "쿠팡페이",
	// 	indstCd: "efin"
	// },
	{
		insttCd: "F1AAAN0000",
		insttNm: "KT",
		indstCd: "telecom"
	},
	{
		insttCd: "F1AAAU0000",
		insttNm: "에스케이텔레콤주식회사",
		indstCd: "telecom"
	},
	{
		insttCd: "F1AAGI0000",
		insttNm: "LG유플러스",
		indstCd: "telecom"
	}
]

export default best50